import store from "../Redux/Store";

const storeData = store.getState().storeReducer.store;

/**
 * Mailer function to be used for support requests
 */
export const supportRequestMailToExpertDotpe = () => {
  const mailString = `mailto:expert@dotpe.in?subject=Support request for Digital Showroom <Store ID -(${
    storeData?.store_id ? storeData?.store_id : ""
  })>&body=%28Please do not edit subject line - Digital Showroom %7CStore ID - %3C${
    storeData?.store_id
  }%3E%29%0D%0A%0D%0ALet our experts know what issue you are facing%0D%0AStart writing below %F0%9F%91%87`;

  window.open(mailString, "_blank");
};
